import type { ExerciseId, FigureFrames } from '@/domain/exercise'

/**
 * Monigotes de dos fotogramas. Alternando los dos se lee el movimiento
 * completo sin necesidad de vídeo ni de red.
 *
 * Cada polilínea es una lista plana de pares x,y sobre un lienzo de 100x100.
 */
export const FIGURES: Record<string, FigureFrames> = {
  jumping_jacks: [
    {
      head: [50, 20],
      lines: [
        [50, 27, 50, 56],
        [50, 33, 36, 54],
        [50, 33, 64, 54],
        [50, 56, 44, 88],
        [50, 56, 56, 88],
      ],
    },
    {
      head: [50, 20],
      lines: [
        [50, 27, 50, 56],
        [50, 33, 30, 16],
        [50, 33, 70, 16],
        [50, 56, 32, 88],
        [50, 56, 68, 88],
      ],
    },
  ],
  skippings: [
    {
      head: [50, 19],
      lines: [
        [50, 26, 50, 56],
        [50, 32, 38, 48],
        [50, 32, 62, 40],
        [50, 56, 42, 60, 42, 76],
        [50, 56, 56, 88],
      ],
    },
    {
      head: [50, 19],
      lines: [
        [50, 26, 50, 56],
        [50, 32, 38, 40],
        [50, 32, 62, 48],
        [50, 56, 44, 88],
        [50, 56, 58, 60, 58, 76],
      ],
    },
  ],
  air_squats: [
    {
      head: [52, 18],
      lines: [
        [52, 25, 50, 54],
        [50, 32, 66, 36],
        [50, 54, 50, 70, 50, 88],
      ],
    },
    {
      head: [57, 44],
      lines: [
        [55, 51, 44, 77],
        [54, 54, 70, 52],
        [44, 77, 60, 73, 50, 88],
      ],
    },
  ],
  shoulder_taps: [
    {
      head: [74, 52],
      lines: [
        [68, 56, 28, 68],
        [69, 56, 73, 84],
        [67, 57, 56, 49],
        [28, 68, 16, 84],
      ],
    },
    {
      head: [74, 52],
      lines: [
        [68, 56, 28, 68],
        [66, 57, 62, 84],
        [69, 56, 58, 60],
        [28, 68, 16, 84],
      ],
    },
  ],
  push_ups: [
    {
      head: [74, 50],
      lines: [
        [68, 54, 26, 68],
        [68, 54, 70, 84],
        [26, 68, 14, 84],
      ],
    },
    {
      head: [72, 72],
      lines: [
        [66, 76, 26, 80],
        [66, 76, 55, 82, 70, 84],
        [26, 80, 14, 87],
      ],
    },
  ],
  lunges: [
    {
      head: [50, 18],
      lines: [
        [50, 25, 50, 54],
        [50, 31, 46, 50],
        [50, 54, 50, 70, 50, 88],
      ],
    },
    {
      head: [50, 33],
      lines: [
        [49, 40, 48, 68],
        [49, 43, 45, 62],
        [48, 68, 66, 70, 66, 88],
        [48, 68, 36, 80, 18, 88],
      ],
    },
  ],
  mountain_climbers: [
    {
      head: [76, 50],
      lines: [
        [70, 54, 30, 66],
        [70, 54, 72, 82],
        [30, 66, 54, 58, 52, 76],
        [30, 66, 12, 84],
      ],
    },
    {
      head: [76, 50],
      lines: [
        [70, 54, 30, 66],
        [70, 54, 72, 82],
        [30, 66, 42, 70, 40, 84],
        [30, 66, 16, 76],
      ],
    },
  ],
  sit_ups: [
    {
      head: [20, 68],
      lines: [
        [26, 70, 52, 74],
        [26, 70, 30, 84],
        [52, 74, 70, 62, 74, 80],
      ],
    },
    {
      head: [38, 44],
      lines: [
        [44, 50, 54, 74],
        [44, 50, 64, 52],
        [54, 74, 70, 62, 74, 80],
      ],
    },
  ],
  // El burpee recorre camino: de pie, al suelo, pecho abajo y salto. Con dos
  // poses se perdía la mitad del movimiento.
  burpees: [
    {
      head: [50, 20],
      lines: [
        [50, 27, 50, 56],
        [50, 33, 56, 52],
        [50, 56, 45, 88],
        [50, 56, 55, 88],
      ],
    },
    {
      head: [62, 54],
      lines: [
        [58, 60, 44, 70],
        [58, 60, 66, 84],
        [44, 70, 42, 86],
      ],
    },
    {
      head: [78, 74],
      lines: [
        [72, 78, 36, 82],
        [72, 78, 74, 88],
        [36, 82, 18, 88],
      ],
    },
    {
      head: [50, 14],
      lines: [
        [50, 21, 50, 54],
        [50, 27, 36, 8],
        [50, 27, 64, 8],
        [50, 54, 44, 80],
        [50, 54, 56, 80],
      ],
    },
  ],
  squat_jump: [
    {
      head: [57, 44],
      lines: [
        [55, 51, 44, 77],
        [54, 54, 70, 52],
        [44, 77, 60, 73, 50, 88],
      ],
    },
    {
      head: [50, 26],
      lines: [
        [50, 33, 50, 60],
        [50, 38, 62, 44],
        [50, 60, 48, 88],
      ],
    },
    {
      head: [50, 14],
      lines: [
        [50, 21, 50, 50],
        [50, 27, 36, 10],
        [50, 27, 64, 10],
        [50, 50, 46, 74],
        [50, 50, 56, 74],
      ],
    },
  ],
  pike_push_ups: [
    {
      head: [66, 48],
      lines: [
        [70, 54, 42, 40],
        [70, 54, 78, 84],
        [42, 40, 32, 84],
      ],
    },
    {
      head: [78, 76],
      lines: [
        [72, 70, 42, 44],
        [72, 70, 84, 80],
        [42, 44, 32, 86],
      ],
    },
  ],
  glute_bridge: [
    {
      head: [16, 70],
      lines: [
        [24, 73, 50, 78],
        [26, 76, 40, 84],
        [50, 78, 68, 66, 68, 86],
      ],
    },
    {
      head: [16, 70],
      lines: [
        [24, 73, 52, 62],
        [26, 76, 40, 84],
        [52, 62, 68, 62, 68, 86],
      ],
    },
  ],
  // Cuatro poses: las dos de trabajo y las dos de cruce. Sin las de cruce las
  // piernas parecían quietas y el codo no llegaba a girar.
  bicycle_crunch: [
    {
      head: [22, 44],
      lines: [
        [28, 50, 58, 76],
        [27, 47, 16, 32],
        [30, 54, 46, 60],
        [58, 76, 40, 52, 52, 42],
        [58, 76, 90, 84],
      ],
    },
    {
      head: [22, 50],
      lines: [
        [28, 56, 58, 77],
        [27, 53, 14, 40],
        [30, 60, 42, 68],
        [58, 77, 46, 60, 60, 52],
        [58, 77, 88, 76],
      ],
    },
    {
      head: [22, 44],
      lines: [
        [28, 50, 58, 76],
        [27, 47, 16, 32],
        [30, 56, 44, 68],
        [58, 76, 44, 56, 58, 48],
        [58, 76, 90, 68],
      ],
    },
    {
      head: [22, 50],
      lines: [
        [28, 56, 58, 77],
        [27, 53, 14, 40],
        [30, 60, 42, 58],
        [58, 77, 46, 62, 60, 56],
        [58, 77, 88, 72],
      ],
    },
  ],
  skaters: [
    {
      head: [58, 22],
      lines: [
        [58, 29, 56, 54],
        [58, 34, 74, 40],
        [58, 34, 44, 30],
        [56, 54, 64, 84],
        [56, 54, 44, 70, 38, 80],
      ],
    },
    {
      head: [42, 22],
      lines: [
        [42, 29, 44, 54],
        [42, 34, 26, 40],
        [42, 34, 56, 30],
        [44, 54, 36, 84],
        [44, 54, 56, 70, 62, 80],
      ],
    },
  ],
  tricep_dips: [
    {
      head: [42, 28],
      lines: [
        [42, 35, 46, 56],
        [42, 38, 56, 60],
        [46, 56, 28, 66, 28, 86],
      ],
    },
    {
      head: [42, 42],
      lines: [
        [42, 49, 46, 66],
        [42, 52, 58, 48, 56, 60],
        [46, 66, 28, 72, 28, 86],
      ],
    },
  ],
  // La oruga entera: las manos caminan hasta la plancha, pecho al suelo, y el
  // mismo camino de vuelta hasta ponerse de pie. Los pies no se mueven.
  inchworm: [
    {
      head: [64, 24],
      lines: [
        [64, 31, 64, 54],
        [64, 34, 60, 54],
        [64, 54, 68, 86],
      ],
    },
    {
      head: [54, 66],
      lines: [
        [58, 62, 64, 52],
        [64, 52, 68, 86],
        [58, 62, 52, 84],
      ],
    },
    {
      head: [40, 60],
      lines: [
        [44, 56, 60, 46],
        [60, 46, 68, 86],
        [44, 56, 32, 84],
      ],
    },
    {
      head: [26, 58],
      lines: [
        [30, 62, 50, 70],
        [50, 70, 70, 86],
        [30, 62, 20, 84],
      ],
    },
    {
      head: [22, 74],
      lines: [
        [28, 78, 50, 82],
        [50, 82, 70, 88],
        [28, 78, 26, 88],
      ],
    },
    {
      head: [26, 56],
      lines: [
        [30, 60, 50, 68],
        [50, 68, 70, 86],
        [30, 60, 22, 84],
      ],
    },
    {
      head: [44, 58],
      lines: [
        [48, 54, 62, 46],
        [62, 46, 68, 86],
        [48, 54, 38, 84],
      ],
    },
    {
      head: [58, 64],
      lines: [
        [60, 60, 64, 50],
        [64, 50, 68, 86],
        [60, 60, 56, 84],
      ],
    },
  ],
  superman: [
    {
      head: [76, 74],
      lines: [
        [70, 76, 30, 80],
        [70, 76, 84, 80],
        [30, 80, 14, 84],
      ],
    },
    {
      head: [78, 64],
      lines: [
        [72, 67, 30, 78],
        [72, 67, 88, 58],
        [30, 78, 14, 68],
      ],
    },
  ],
  leg_raises: [
    {
      head: [16, 66],
      lines: [
        [24, 69, 52, 72],
        [24, 71, 26, 84],
        [52, 72, 84, 78],
      ],
    },
    {
      head: [16, 66],
      lines: [
        [24, 69, 52, 72],
        [24, 71, 26, 84],
        [52, 72, 60, 44],
      ],
    },
  ],
  side_plank_dip: [
    {
      head: [20, 46],
      lines: [
        [26, 52, 50, 62, 76, 74],
        [26, 52, 22, 72],
        [26, 50, 26, 28],
      ],
    },
    {
      head: [20, 52],
      lines: [
        [26, 58, 50, 76, 76, 78],
        [26, 58, 22, 74],
        [26, 56, 26, 34],
      ],
    },
  ],
  // Los isométricos van con una sola pose: en la pared o en la plancha no hay
  // nada que animar, y el monigote quieto ya dice lo que hay que hacer.
  plank: [
    {
      head: [76, 52],
      lines: [
        [70, 56, 30, 70],
        [70, 56, 72, 78, 86, 80],
        [30, 70, 14, 84],
      ],
    },
  ],
  wall_sit: [
    {
      head: [18, 32],
      lines: [
        [6, 12, 6, 88],
        [18, 39, 18, 62],
        [18, 62, 50, 62],
        [50, 62, 50, 86],
        [18, 45, 40, 50],
      ],
    },
  ],
  reverse_lunges: [
    {
      head: [50, 18],
      lines: [
        [50, 25, 50, 54],
        [50, 31, 54, 50],
        [50, 54, 50, 70, 50, 88],
      ],
    },
    {
      head: [54, 30],
      lines: [
        [53, 37, 52, 64],
        [53, 40, 58, 58],
        [52, 64, 56, 88],
        [52, 64, 32, 74, 26, 88],
      ],
    },
  ],
  high_knees: [
    {
      head: [50, 18],
      lines: [
        [50, 25, 50, 54],
        [50, 31, 38, 44],
        [50, 31, 62, 36],
        [50, 54, 52, 88],
        [50, 54, 34, 42, 42, 56],
      ],
    },
    {
      head: [50, 18],
      lines: [
        [50, 25, 50, 54],
        [50, 31, 62, 44],
        [50, 31, 38, 36],
        [50, 54, 48, 88],
        [50, 54, 66, 42, 58, 56],
      ],
    },
  ],
  bear_crawl: [
    {
      head: [78, 46],
      lines: [
        [72, 50, 36, 60],
        [72, 50, 74, 84],
        [36, 60, 44, 70, 42, 84],
      ],
    },
    {
      head: [78, 46],
      lines: [
        [72, 50, 36, 60],
        [72, 50, 62, 68, 66, 84],
        [36, 60, 28, 84],
      ],
    },
  ],
  hollow_hold: [
    {
      head: [30, 50],
      lines: [
        [34, 56, 56, 72],
        [32, 53, 12, 40],
        [56, 72, 86, 56],
      ],
    },
  ],
  // Precarga, vuelo y aterrizaje: el salto avanza de izquierda a derecha. En el
  // fotograma del aire nada llega al suelo, que es lo que lo hace legible.
  broad_jumps: [
    {
      head: [22, 40],
      lines: [
        [24, 47, 28, 64],
        [24, 50, 10, 58],
        [28, 64, 38, 74, 30, 88],
      ],
    },
    {
      head: [52, 24],
      lines: [
        [54, 31, 44, 48],
        [54, 30, 70, 20],
        [44, 48, 56, 56, 44, 66],
      ],
    },
    {
      head: [78, 44],
      lines: [
        [76, 51, 72, 68],
        [76, 53, 90, 48],
        [72, 68, 82, 78, 74, 88],
      ],
    },
  ],
  single_leg_glute_bridge: [
    {
      head: [16, 70],
      lines: [
        [24, 73, 50, 78],
        [26, 76, 40, 84],
        [50, 78, 68, 66, 68, 86],
        [50, 78, 82, 74],
      ],
    },
    {
      head: [16, 70],
      lines: [
        [24, 73, 52, 62],
        [26, 76, 40, 84],
        [52, 62, 68, 62, 68, 86],
        [52, 62, 84, 50],
      ],
    },
  ],
  cossack_squat: [
    {
      head: [50, 18],
      lines: [
        [50, 25, 50, 52],
        [50, 31, 34, 38],
        [50, 31, 66, 38],
        [50, 52, 32, 86],
        [50, 52, 68, 86],
      ],
    },
    {
      head: [64, 40],
      lines: [
        [64, 47, 64, 64],
        [64, 50, 48, 48],
        [64, 64, 74, 74, 72, 88],
        [64, 64, 26, 86],
      ],
    },
  ],
  // Flexión abajo, flexión arriba y perro: son tres posiciones distintas y con
  // dos poses el paso por la flexión se perdía.
  push_up_down_dog: [
    {
      head: [76, 78],
      lines: [
        [70, 82, 32, 84],
        [70, 82, 60, 76, 72, 88],
        [32, 84, 16, 90],
      ],
    },
    {
      head: [76, 56],
      lines: [
        [70, 60, 30, 70],
        [70, 60, 72, 86],
        [30, 70, 14, 86],
      ],
    },
    {
      head: [62, 52],
      lines: [
        [68, 56, 44, 32],
        [68, 56, 80, 86],
        [44, 32, 26, 86],
      ],
    },
  ],
}

export function getFigure(id: ExerciseId): FigureFrames | null {
  return FIGURES[id] ?? null
}
